<template>
    <div class="nav-list-header" :class="[sizeString ? 'text-' + sizeString : '']">
        <slot/>
    </div>
</template>

<script>
import Sizeable from "../../../mixins/Sizeable";

    export default {
        name: "NavListHeader",

        mixins: [Sizeable],

        props: {

        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
.nav-list-header {
  display: flex;
  align-items: center;
  font-weight: 400;
  padding: 0 8px;
  height: 40px;
  margin-top: 8px;
  color: #5e6b6b;
}
.nav-list-header.text-xs {
  height: 32px;
}
.nav-list-header.text-sm {
  height: 36px;
}
</style>